<template>
  <!-- جای router-view در SiteLayout: محتوای صفحه فعلی -->
  <template v-if="isRouterViewPlaceholder && hasInjectedPage">
    <component-manager
      v-for="item in injectPageComponents"
      :key="'page-' + item.id + ':' + (item.name || '')"
      :component="item"
    />
  </template>

  <component
    v-else-if="resolvedComponentIs"
    ref="selected_component_prop"
    :data-selector="`component-${component.id}`"
    :class="component.class"
    :style="component.css"
    v-bind="vBindValue"
    :is="resolvedComponentIs"
  >
    <template v-for="(content, key) in safeSlots" #[key]>
      {{ content.text }}
      <component-manager
        v-for="item in (content.components || [])"
        :key="item.id + ':' + (item.name || '')"
        :component="item"
        :inject-page-components="injectPageComponents"
        :virtual-preview="virtualPreview"
      />
    </template>
  </component>

  <div v-else class="miw-missing-component" :data-selector="`component-${component?.id}`">
    کامپوننت نامعتبر: {{ component?.name || '(بدون نام)' }}
  </div>
</template>

<script>
import {mapActions} from "vuex";
import * as miwComponents from '@moeinmdn/miw-alpha-components/src/package/IndexComponentMap'
import {generateRandomString, setComponentPropValues} from "@/store/Modules/Site";

export default {
  name: "ComponentManager",
  components: {},
  props: {
    component: {
      required: true
    },
    // کامپوننت‌های صفحه فعلی برای تزریق داخل m-router-view (پیش‌نمایش مجازی SiteLayout)
    injectPageComponents: {
      type: Array,
      default: null,
    },
    // لایه‌های SiteLayout فقط برای نمایش هستند؛ init روی صفحه فعلی نباید اجرا شود
    virtualPreview: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      miwComponents,
      jsonComponent: null,
    }
  },
  computed: {
    generateRandomString,
    vBindValue() {
      return {...(this.component?.props || {}), ...(this.component?.dataAttribute || {})}
    },
    resolvedComponentIs() {
      const name = this.component?.name
      if (!name || typeof name !== 'string') return null
      return name
    },
    safeSlots() {
      return this.component?.slots && typeof this.component.slots === 'object'
        ? this.component.slots
        : {}
    },
    isRouterViewPlaceholder() {
      const name = (this.component?.name || '').toLowerCase()
      return name === 'm-router-view' || name === 'router-view' || name === 'm-routerview'
    },
    hasInjectedPage() {
      return Array.isArray(this.injectPageComponents)
    },
  },
  methods: {
    ...mapActions({
      findComponentPath: 'Site/findComponentPath',
      pathToComponent: 'Site/pathToComponent'
    }),
    setComponentPropValues,
    async setComponentProps() {
      if (!this.$refs.selected_component_prop) return false
      const refProps = this.$refs.selected_component_prop.$props
      const componentProps = this.component.props || {};
      let validaProps = {}
      Object.keys(refProps).forEach(item => {
        if (Object.keys(componentProps).indexOf(item) > -1) {
          validaProps[item] = componentProps[item]
        } else {
          validaProps[item] = refProps[item]
        }
      })

      this.jsonComponent.rawProps = this.$refs.selected_component_prop.$options.props
      this.jsonComponent.props = this.setComponentPropValues(validaProps, this.jsonComponent);

      return true
    },
    setComponentSlots() {
      if (!this.jsonComponent || !this.miwComponents[this.jsonComponent.detail?.tag?.name]) return
      let componentSlots = this.miwComponents[this.jsonComponent.detail.tag.name].slots;
      componentSlots.forEach(positionName => {

        const checkSlotPositionContent = Object.keys(this.component.slots || {}).indexOf(positionName)

        if (checkSlotPositionContent > -1) {
          this.jsonComponent.slots[positionName] = this.component.slots[positionName]
        } else {
          this.jsonComponent.slots[positionName] = {
            components: [],
            text: "",
          }
        }
      })

    },
    async setComponent() {
      let componentPath = await this.findComponentPath(this.component.id)
      if (!componentPath) return
      this.jsonComponent = await this.pathToComponent({componentPath})
    },
    async initComponentManager() {
      await this.setComponent()
      if (!this.jsonComponent) return
      await this.setComponentSlots()
      await this.setComponentProps()
    },
  },
  mounted() {
    if (this.virtualPreview || this.isRouterViewPlaceholder) return
    if (!this.resolvedComponentIs) return
    this.initComponentManager()
  },
}
</script>

<style scoped>
.active-selected-component {
  border: 3px solid #000;
}

.miw-missing-component {
  padding: 6px 10px;
  margin: 4px 0;
  font-size: 12px;
  color: #b91c1c;
  background: #fef2f2;
  border: 1px dashed #fca5a5;
}
</style>
